import InitialsLogo from "src/components/InitialsLogo";
import Table from "src/components/Tables/Table";
import { JobInterview } from "src/types";
import { dateFormat1 } from "src/utils/dates/formats";
import { InterviewTable } from "./type";
import LinkButton from "src/components/LinkButton";

const ShortlistedTable = ({ data }: InterviewTable) => {
  return (
    <Table
      data={data}
      heads={["Name | Email Address", "Recruiter", "Score", "Date Taken", "Action"]}
      row={(i: JobInterview) => {
        const { email, first_name, last_name, Interview, slug, Inviter } = i;
        const { ai_score, date_completed } = Interview;
        return [
          <div>
            <p>{`${first_name} ${last_name}`}</p>
            <p className="max-w-[207px] overflow-hidden text-ellipsis mt-2">{email}</p>
          </div>,
          Inviter ? <InitialsLogo user={Inviter.User} /> : "N/A",
          <p className="max-w-[30px] overflow-hidden text-ellipsis">
            {ai_score ? ai_score + "%" : "-"}
          </p>,
          <p>{date_completed ? dateFormat1(date_completed) : "-"}</p>,
          <div className="flex gap-4 ">
            <LinkButton
              href={date_completed ? "/job/interview/" + slug : undefined}
              target="_blank"
              buttonProps={{
                disabled: !date_completed,
                className: "!text-sm !rounded-3xl !w-fit !px-4"
              }}
            >
              View Insights
            </LinkButton>
          </div>
        ];
      }}
    />
  );
};

export default ShortlistedTable;
